import React from 'react';
import MyAdvisor from 'templates/DebtOverviewPageData/components/MyAdvisor/MyAdvisor';
import MyCaseStatus from 'templates/DebtOverviewPageData/components/MyCaseStatus/MyCaseStatus';

import styles from './SecuredPerformCard.module.scss';
interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const SecuredPerformCard = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  return (
    <div className={styles.SecuredPerformCard_wrapper}>
      <MyAdvisor {...props} />
      <MyCaseStatus {...props} />
    </div>
  );
};

export default SecuredPerformCard;
